import type { GlobalSearchResultItem } from 'models';
import { useTranslation } from 'react-i18next';

import { SearchItemContent } from '../search-item-content';
import { SearchItemRow } from '../search-item-row';

type P = {
  itemActionProps?: Record<string, unknown>;
  itemProps: GlobalSearchResultItem;
};

const PostItem = ({ itemActionProps, itemProps }: P) => {
  const { t } = useTranslation();
  const title = itemProps.name ?? itemProps.textContent ?? itemProps.description ?? '';

  return (
    <SearchItemRow itemActionProps={itemActionProps}>
      <SearchItemContent
        subtitle={
          itemProps.postInCommunities?.[0]
            ? t('postSearchItemDate', {
                community: itemProps.postInCommunities[0].name,
                date: itemProps.createdAt,
              })
            : t('dateFormats.shortMonthDayYear', { date: itemProps.createdAt })
        }
        title={title}
      />
    </SearchItemRow>
  );
};

export default PostItem;
